import React from 'react';
import styles from './CreatorPayments.module.css';
import { TabNavItem, TabPanel, TabPanels, Tabs } from '@round/ui-kit';
import useUrlState from '../../../hooks/useUrlState';
import PastPayments from './PastPayments/PastPayments';
import OutstandingPayments from './OutstandingPayments/OutstandingPayments';

type UrlState = Partial<{ tab: string }>;

const OUTSTANDING_PAYMENTS_TABLE = 'outstanding';
const PAST_PAYMENTS_TABLE = 'past';

const CreatorPayments = () => {
    const [urlState, setUrlState] = useUrlState<UrlState>({ tab: OUTSTANDING_PAYMENTS_TABLE });

    return (
        <>
            <div className={styles.container}>
                <Tabs activeTab={urlState.tab} onChange={(tab) => setUrlState({ tab }, true)}>
                    <div className={styles.tabNavContainer}>
                        <TabNavItem
                            className={styles.tabItem}
                            activeClassName={styles.tabItemActive}
                            name={OUTSTANDING_PAYMENTS_TABLE}
                        >
                            Outstanding
                        </TabNavItem>
                        <TabNavItem
                            className={styles.tabItem}
                            activeClassName={styles.tabItemActive}
                            name={PAST_PAYMENTS_TABLE}
                        >
                            Payments
                        </TabNavItem>
                    </div>

                    <div className={styles.contentCard}>
                        <TabPanels>
                            <TabPanel name={OUTSTANDING_PAYMENTS_TABLE}>
                                <OutstandingPayments />
                            </TabPanel>

                            <TabPanel name={PAST_PAYMENTS_TABLE}>
                                <PastPayments />
                            </TabPanel>
                        </TabPanels>
                    </div>
                </Tabs>
            </div>
        </>
    );
};

export default CreatorPayments;
